export enum Shading {
  // shading
  NoShading = 0,
  FlatShading = 1,
  SmoothShading = 2,
}